import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, FormControl, FormHelperText, FormLabel, TextField, Typography } from '@/core/ui';
import { Controller, useForm } from 'react-hook-form';
import { Header, Paper, PaperContainer, RootBox } from './Login.styled';
import { defaultValues, schema } from './Login.yup';
import logo from '@/shared/assets/gp-card-logo.png';
import { sharedLocalStorage } from '@/shared/helpers';
import { useAuthStore } from '@/shared/modules/auth/business';
import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { decodeToken } from './business/decodeToken';
import { submitLogin } from './business/thunk';
import { tokenIsExpired } from './helpers';
const Login = () => {
    const { state } = useLocation();
    const redirectedFrom = state?.pathname || '/';
    const { isTryingToLogin: isLoading, isError, error } = useAuthStore((state) => state.loginDialog);
    const { handleSubmit, control, formState: { errors }, } = useForm({
        resolver: yupResolver(schema),
        defaultValues: defaultValues,
    });
    useEffect(() => {
        const token = sharedLocalStorage.getItem('token');
        if (!token)
            return;
        const expiration = decodeToken(token).expiration;
        if (tokenIsExpired(expiration)) {
            return;
        }
        window.location.replace(redirectedFrom);
    }, [redirectedFrom]);
    const onSubmit = async (data) => {
        submitLogin({ credentials: data, redirectTo: redirectedFrom });
    };
    const onInvalid = (data) => {
        console.log('Validation errors:', data);
    };
    return (_jsxs(RootBox, { children: [_jsx(Header, { children: _jsx("img", { src: logo, alt: "logo" }) }), _jsx(PaperContainer, { maxWidth: false, children: _jsxs(Paper, { elevation: 3, children: [_jsx(Typography, { variant: "h3", sx: {
                                textAlign: 'center',
                                fontWeight: (theme) => theme.typography.fontWeightBold,
                                mb: 3,
                                mt: 3,
                            }, children: "Sign in to your account" }), _jsx("form", { id: "loginForm", onSubmit: handleSubmit(onSubmit, onInvalid), children: _jsxs(Box, { sx: {
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 3,
                                    maxWidth: '24rem',
                                    width: '24rem',
                                    mt: '1rem',
                                }, children: [_jsxs(FormControl, { fullWidth: true, error: Boolean(errors.email), disabled: isLoading, children: [_jsx(FormLabel, { children: "Email" }), _jsx(Controller, { name: "email", control: control, rules: { required: true }, render: ({ field }) => _jsx(TextField, { fullWidth: true, ...field }) }), _jsx(FormHelperText, { children: errors.email?.message })] }), _jsxs(FormControl, { fullWidth: true, error: Boolean(errors.password), disabled: isLoading, children: [_jsx(FormLabel, { children: "Password" }), _jsx(Controller, { name: "password", control: control, render: ({ field }) => _jsx(TextField, { fullWidth: true, ...field, type: "password", autoComplete: "current-password" }) }), _jsx(FormHelperText, { children: errors.password?.message })] })] }) }), _jsx(Button, { variant: "contained", type: "submit", form: "loginForm", loading: isLoading, disabled: isLoading, sx: { mt: 5, width: '100%' }, children: "Login" }), _jsx(Box, { sx: {
                                color: 'error.main',
                                py: 3,
                                px: 1,
                            }, children: isError && (_jsx(Typography, { variant: "body1", component: "h3", children: `Error occurred: ${error}` })) })] }) })] }));
};
export { Login };
